import {filter, map} from 'rxjs/operators';
import {wsMsg$} from '@/ws';
import type {ws} from '@/types';
type ContractMarketMsg = ws.ContractMarketMsg;
type ContractMarketRaw = ws.ContractMarketRaw;
type ContractMarketData = ws.ContractMarketData;

export const contractMarket24hData$ = wsMsg$.pipe(
  filter((o: ContractMarketMsg) => o.method === 'perp_market24h_pack.update'),
  map((o: ContractMarketMsg) => o.data.map(convertContractMarketItem))
);
export const contractMarket24hDataV2$ = wsMsg$.pipe(
  filter((o: ContractMarketMsg) => o.method === 'perp_market24h_pack_p.update'),
  map((o: ContractMarketMsg) => o.data.map(convertContractMarketItem))
);

function convertContractMarketItem(item: ContractMarketRaw): ContractMarketData {
  return {
    symbol: item[0],
    open: Number(item[1]),
    high: Number(item[2]),
    low: Number(item[3]),
    close: Number(item[4]),
    volume: Number(item[5]),
    turnover: Number(item[6]),
    openInterest: Number(item[7]),
    indexPrice: Number(item[8]),
    markPrice: Number(item[9]),
    fundingRate: Number(item[10]),
    predFundingRate: Number(item[11]),
    bid: Number(item[12] || 0),
    ask: Number(item[13] || 0),
  };
}
